const appFetch = async ({
  url,
  method = "get",
  extraHeaders = {},
  body,
  onSuccess,
  onError,
  onFinalize,
  clearHeader = false
}) => {
  let defaultHeaders = {
    'Content-Type': 'application/json',
    'PublicKey': localStorage.getItem('publicKey'),
    'Authorization-token': localStorage.getItem('authorizationToken'),
  }

  if(method === 'get' || method === 'GET'){
    defaultHeaders = {
      'PublicKey': localStorage.getItem('publicKey'),
      'Authorization-token': localStorage.getItem('authorizationToken'),
    }
  }

  try {
    let initialHeaders = {}
    if(!clearHeader){
      initialHeaders = defaultHeaders
    }

    const response = await fetch(url, {
      method: method,
      headers: {...initialHeaders, ...extraHeaders},
      body: body,
    });

    let parsedResponse = null;

    try {
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        parsedResponse = await response.json();
      }
    }
    catch(err){
      console.error('Parsing json error: ', err);
    }

    if (!response.ok) {
      if (typeof onError === "function") {
        await onError(parsedResponse, response);
      }
      return;
    }

    if (typeof onSuccess === "function") {
      await onSuccess(parsedResponse, response);
    }
  } catch (err){
    console.error("Error: ", err)
  } finally {
    if (typeof onFinalize === "function") {
      await onFinalize();
    }
  }
};

export default appFetch;
